<template>
  <div
    :class="$style.descriptionStyle"
    data-test-id="CommandTemplateDescription__Description"
  >
    {{ item.description }}
  </div>
</template>

<script>

export default {
  name: 'CommandTemplateDescription',

  props: {
    item: {
      default: () => ({}),
      type: Object,
    },
  },
};
</script>
<style module>
.descriptionStyle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
